<template>
    <div class="videoCenter">
        <headers :title="$t('视频中心')" img="newsCenter"></headers>
        <el-row :gutter="20">
            <el-col :span="3" :offset="5"><div class="btn InternationalBtn"> <router-link to="/news">{{$t('新闻动态')}}</router-link></div></el-col>
            <el-col :span="3"><div class="btn domesticBtn"><router-link to="/videoCenter">{{$t('视频中心')}}</router-link> </div></el-col>
        </el-row>
        <div class="line"></div>
        <div class="videoList">
            <el-row :gutter="20" v-for="(item, index) in videoList" :key="index">
                <el-col :span="12" v-for="(_item, index2) in item" :key="index2">
                    <div class="videoPreview" @click="playVideo(_item)">
                        <img :src="`${baseUrl}img/video/${_item}.jpg`" width="100%" alt="" srcset="">
                        <img class="icon" src="../../public/img/video/icon.png" alt="" srcset="">
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="play" v-if="playShow">
            <div class="play_center">
                <div class="close" @click="closeViedo()">
                    <img src="../../public/img/video/close.png" alt="" srcset="">
                </div>
                <video v-if="playShow" :width="videoURL=='video1'?'50%':'100%'"  controls="controls">
                    <source :src="`${baseUrl}img/video/${videoURL}.mp4`" type="video/mp4" />
                </video>
            </div>
        </div>
        <foot></foot>
    </div>
</template>
<script>
import headers from "@/components/headers.vue";
import foot from "@/components/foot.vue";
export default {
    components:{
      headers,foot
    },
    data() {
        return {
            baseUrl:process.env.BASE_URL, 
            playShow:false,
            videoList:[
                [
                    'video5','video4'
                ],
                [
                    'video1','video2'
                ],
                [
                    'video3'
                ]
            ],
            videoURL:''
        }
    },
    methods:{
        playVideo(item){
            this.playShow = true
            this.videoURL = item
            console.log(this.videoURL)
        },
        closeViedo(){
            this.playShow = false
        }
    }

}
</script>
<style lang="less">
.videoCenter{
    .line{
        border-bottom: 1px solid #BFBFBF;
        width: 100%;
        // background-color: #BFBFBF;
    }
    .play{
        position: fixed;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        left: 0;
        top: 0;
        .play_center{
            width: 50vw;
            height: 50vh;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            .close{
                position: absolute;
                right: 0;
                top: 0;
                transform: translate(100%,-20px);
            }
            video{
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
            }
        }   
    }
    .videoList{
        width: 60%;
        margin: 3rem auto;
        .videoPreview{
            width: 100%;
            margin-bottom: 20px;
            position: relative;
            .icon{
                position: absolute;
                width: 50px;
                z-index: 100;
                left: 50%;
                top: 50%;
                transform: translate(-50%,-50%);
                cursor: pointer;
            }
            .icon:hover{
                transform: translate(-50%,-50%) scale(1.1);
            }
        }
    }
    .btn{
        line-height: 3rem;
        font-size: 0.8rem;
        cursor: pointer;
    }
    .domesticBtn a{
        color: #565656;  
        text-decoration: none;      
    }
    .InternationalBtn a{
        color: #A0A0A0;
        text-decoration: none;
    }
}
</style>
<i18n>
{
  "en": {
       "新闻动态":"News",
       "视频中心":"Video Center",
       "新闻中心":"News Center"
  },
  "zh": {
       "新闻动态":"新闻动态", 
       "视频中心":"视频中心",
       "新闻中心":"新闻中心"
    }
}
</i18n>

